<template>
  <div>
    <Header :title="title"/>
    <div  v-if="getkateg == 'avto'">
     <div class="footer_podat" v-if="sena">
      <div class="main">
        <div align="center">
          <button class="btns" @click="dale()">Далее</button>
        </div>
      </div>
    </div>
    </div>
    <div v-else>
      <div class="footer_podat" v-if="sena && zagolovok">
      <div class="main">
        <div align="center">
          <button class="btns" @click="dale()">Далее</button>
        </div>
      </div>
    </div>
    </div>
    

    <div class="content_podat">
      <div v-if="getkateg != 'avto'" >
        <div class="div_placeholder">
          Заголовок 
          <span v-if="getkateg=='gruzspes' || getkateg=='moto'">(модел)</span>
          </div>      
            <input
              type="text"
              class="inputtt"
              v-model.trim="zagolovok"
              placeholder=""
            />
        <div class="success">{{ text_success_zagolovok }}</div>
      </div>


      <div>
        <div class="div_placeholder">Укажите цену</div>
        <div class="content_sena border_input">
          <table>
            <tr>
              <td class="td_sena">
                <input
                  type="number"
                  class="inputt"
                  v-model.trim="sena"
                  placeholder="Цена"
                />
              </td>
              <td  class="tdsomoni">
                <div class="text_somoni">сомони</div>
              </td>
            </tr>
          </table>
        </div>
        <div class="success">{{ text_success_sena }}</div>
        <div class="checkbox">
          <input
            class="custom-checkbox"
            v-model="torg"
            type="checkbox"
            id="torg"
            name="torg"
            value="indigo"
          />
          <label for="torg">Торг есть</label>
        </div>
      </div>
      
      <div v-if="getkateg=='avto' || getkateg=='gruzspes' || getkateg=='moto'" >
        <br /><br />
        <div class="div_placeholder">Укажите пробег</div>
        <div class="content_sena border_input">
          <table>
            <tr>
              <td class="td_sena">
                <input
                  type="number"
                  class="inputt"
                  v-model.trim="probeg"
                  placeholder="Пробег в км"
                />
              </td>
              <td class="tdsomoni">
                <div class="text_somoni">км</div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <br /><br />
      <div class="checkbox"  v-if="getkateg == 'avto'">
          <input
            class="custom-checkbox"
            v-model="gosnomer"
            type="checkbox"
            id="gosnomer"
            name="gosnomer"
            value="indigo"
          />
          <label for="gosnomer">Скрыть госномер автомобиля</label>
        </div>
        <br /><br />
      <div v-if="displaybody">
        <div class="div_placeholder">Описание</div>
        <resizable-textarea ref="resize">
          <textarea
            ref="textarea"
            rows="2"
            class="textareat"
            v-model.trim="body"
            placeholder="Дополнительная информация"
          ></textarea>
        </resizable-textarea>
        <div class="success">{{ text_success_body }}</div>
      </div>
      <div v-if="this.getkateg=='zapak'">
        <br/>
        <div class="div_placeholder">Состояние</div><br/>
        <table width="300px">
          <tr>
            <td>
              <div>
                <input
                  class="custom-radio"
                  name="color"
                  v-model="sostoyanie"
                  type="radio"
                  id="new"
                  value="new"
                />
                <label for="new">Новые</label>
              </div>
            </td>
            <td>
              <div>
                <input
                  class="custom-radio"
                  name="color"
                  v-model="sostoyanie"
                  type="radio"
                  id="bu"
                  value="bu"
                />
                <label for="bu">Б/у</label>
              </div>
            </td>
          </tr>
        </table>
       
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/headerpodat'
import ResizableTextarea from "../blocks/ResizableTextarea";
export default {
  components: {
    ResizableTextarea, Header
  },
  data() {
    return {
      title:"Инфо",
      sena: "",
      body: "",
      probeg: "",
      zagolovok:"",
      displaybody: false,
      torg: false,
      gosnomer:false,
      sostoyanie:"",
      text_success_body: "",
      text_success_sena: "",
      text_success_zagolovok: "",
    };
  },
  methods: {
    dale() {
      this.$store.commit("addpodatsena",this.sena);
      this.$store.commit("addpodatbody",this.body);
      this.$store.commit("addpodattorg",this.torg);
      this.$store.commit("addpodatgosnomer",this.gosnomer);
      this.$store.commit("addpodatprobeg",this.probeg);
      this.$store.commit("addpodatzagolovok",this.zagolovok);
      this.$store.commit("addpodatsostoyanie",this.sostoyanie);
      if(this.getkateg=="avto" || this.getkateg=="gruzspes" ){
        this.$router.push({ name: "obmenpodat" });
      }else{
        this.$router.push({ name: "foto" });
      }
      
    },
  },
  computed: {
    getsena() {
      return this.$store.getters.getpodatsena;
    },
    getprobeg() {
      return this.$store.getters.getpodatprobeg;
    },
    getbody() {
      return this.$store.getters.getpodatbody;
    },
    gettorg() {
      return this.$store.getters.getpodattorg;
    },
    getgosnomer() {
      return this.$store.getters.getpodatgosnomer;
    },
     getkateg() {
      return this.$store.getters.getpodatkateg;
    },
     getzagolovok() {
      return this.$store.getters.getpodatzagolovok;
    },
    getsostoyanie() {
      return this.$store.getters.getpodatsostoyanie;
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.go(-1);
    }
  },
  mounted() {
    if (this.getsena) {
      this.sena = this.getsena;
    }
    if (this.getprobeg) {
      this.probeg = this.getprobeg;
    }
    if (this.getbody) {
      this.body = this.getbody;
    }
    if (this.gettorg) {
      this.torg = this.gettorg;
    }
    if (this.getgosnomer) {
      this.gosnomer = this.getgosnomer;
    }
    if (this.getzagolovok) {
      this.zagolovok = this.getzagolovok;
    }
    if (this.getsostoyanie) {
      this.sostoyanie = this.getsostoyanie;
    }
    this.displaybody = true;
  },
};
</script>
<style scoped>
.div_placeholder {
  height: 20px;
  font-size: 18px;
  color: #222;
  margin-bottom: 3px;
}
.text_somoni {
  font-size: 18px;
  color: #333;
  padding: 8px 1px 8px 1px;
  border-left: 1px solid #777;
  margin-left: -2px;
}
.td_sena {
  width: 100%;
}
.tdsomoni{
  min-width: 4.8em;
  text-align: center;
}
.inputt {
  width: 98%;
  border: 1px solid #fff;
  padding: 10px 0px 10px 5px;
  font-size: 18px;
}
.inputtt {
  width: 98%;
  border: 1px solid #555;
  padding: 12px 0px 12px 5px;
  font-size: 18px;
  border-radius: 5px;
}
.border_input{
  border:1px solid #555;
  border-radius: 5px;
}
.textareat {
  width: 98%;
  border: 1px solid #555;
  padding: 5px 0px 5px 5px;
  font-size: 18px;
  resize: none;
  border-radius: 5px;
}
.success {
  height: 15px;
  font-size: 15px;
  color: #c20404;
  margin-left: 3px;
}
label {
  font-size: 18px;
  width: 100%;
}
.content_podat {
  padding: 90px 5px 65px 10px;
}
</style>